import type { SchemaTypes } from '@allesauto/graphql';
import { ViewModes } from '@allesauto/utils/consts';
import { useNumberOfItemsRow } from '@allesauto/utils/hooks';
import clsx from 'clsx';
import * as React from 'react';

import ProductCard from '../productCard';

export interface ProductCardListProps {
  customClass?: string;
  vehicles: SchemaTypes.Vehicle[];
  selectedFinance: SchemaTypes.PriceRange;
  view?: ViewModes;
  openOverlay?: (
    summaryText: string,
    legalText: string,
    financeType: SchemaTypes.PaymentType,
    vehicleName: string,
    vehicleId: string,
    vehicleModel: string,
    vehicleMark: string
  ) => void;
  openLoadingOverlay?: (isOpen: boolean) => void;
  filterCategory?: string;
  filterValue?: any;
  setPersistVehicleState?: (persistentState: any) => any;
  isWhiteLabel?: boolean;
  hasFavorites?: boolean;
}

const ProductCardList = ({
  customClass,
  vehicles,
  view = ViewModes.DEFAULT,
  selectedFinance,
  openOverlay,
  openLoadingOverlay,
  filterCategory,
  filterValue,
  setPersistVehicleState,
  isWhiteLabel = false,
  hasFavorites = true,
}: ProductCardListProps) => {
  const getVehiclesCount = React.useCallback(() => {
    return vehicles.length;
  }, [vehicles]);
  const numberOfItemsRow = useNumberOfItemsRow();

  const additionalTracking = {
    item_list_name: filterCategory ? 'category' : 'search results',
    item_list_id:
      (filterCategory &&
        filterCategory === 'fuelType' &&
        filterValue?.fuelType[0]?.toLocaleLowerCase()) ||
      (filterCategory === 'vehicleCondition' &&
        filterValue?.condition[0]?.toLocaleLowerCase()) ||
      (filterCategory === 'vehicleType' &&
        filterValue?.vehicleType[0]?.toLocaleLowerCase()) ||
      'search results',
  };

  return (
    <div
      className={clsx(
        'gap-10 grid grid-cols-1',
        view === ViewModes.GRID
          ? 'grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-40px'
          : 'grid grid-cols-1',
        customClass
      )}
    >
      {vehicles &&
        vehicles.map((vehicle, index) => (
          <ProductCard
            key={`ProductCard-${index}-${vehicle.id}`}
            view={view}
            vehicle={vehicle}
            selectedFinance={selectedFinance}
            isLastItem={index === getVehiclesCount() - 1}
            openOverlay={openOverlay}
            openLoadingOverlay={openLoadingOverlay}
            numberOfItemsOnRow={numberOfItemsRow}
            additionalTracking={additionalTracking}
            setPersistVehicleState={(persistentState: any) =>
              setPersistVehicleState && setPersistVehicleState(persistentState)
            }
            isWhiteLabel={isWhiteLabel}
            hasFavorites={hasFavorites}
          />
        ))}
    </div>
  );
};

export default ProductCardList;
